import { createElementVNode as _createElementVNode, openBlock as _openBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "mr-1 flex-shrink-0",
  height: "60",
  width: "60"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-wallet" })
], -1)
const _hoisted_3 = { class: "py-1" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  class: "text-success",
  style: {"margin-right":"4px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_Message = _resolveComponent("Message")!

  return (_openBlock(), _createBlock(_component_Message, {
    closable: false,
    severity: "custom"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (!_ctx.layoutStore.isAuthenticated)
            ? (_openBlock(), _createBlock(_component_i18n_t, {
                key: 0,
                keypath: "common.productSummary.loginForWalletAdvantages"
              }, {
                loginLink: _withCtx(() => [
                  _createElementVNode("a", { href: _ctx.loginPageUrl }, _toDisplayString(_ctx.$t("common.login")), 9, _hoisted_4)
                ]),
                registerLink: _withCtx(() => [
                  _createElementVNode("a", { href: _ctx.registerPageUrl }, _toDisplayString(_ctx.$t("common.register")?.toLowerCase()), 9, _hoisted_5)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_i18n_t, {
                key: 1,
                keypath: "common.productSummary.earnWalletCredit"
              }, {
                amount: _withCtx(() => [
                  _createElementVNode("b", _hoisted_6, _toDisplayString(_ctx.formatCurrency(_ctx.walletAmount)), 1)
                ]),
                _: 1
              }))
        ])
      ])
    ]),
    _: 1
  }))
}